import { EPlanCodes, IPlan } from '@/types/Pricing';

export const pricingPlans = (t: (key: string, options?: any) => string): IPlan[] => [
  {
    name: t('Pricing/key6'),
    code: {
      monthly: { USD: EPlanCodes.FREE, EUR: EPlanCodes.FREE_EU },
      annually: { USD: EPlanCodes.FREE, EUR: EPlanCodes.FREE_EU },
    },
    price: {
      monthly: 0,
      annually: 0,
    },
    actionBtnText: t('Pricing/key34'),
    features: [
      {
        name: t('Pricing/includpermonth'),
        category: 'Conversations per month',
        valueType: 'string',
        value: '50',
        inSummary: true,
      },
      {
        name: t('Pricing/whatsapp'),
        category: 'Conversations per month',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/telegram'),
        category: 'Conversations per month',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/key12'),
        category: 'Creations',
        valueType: 'string',
        value: '1',
      },
      {
        name: t('Pricing/textbot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
        inSummary: true,
      },
      {
        name: t('Pricing/videobot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
        inSummary: true,
      },
      {
        name: t('Pricing/quickbot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/docbot'),
        category: 'Creations',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/sitebot'),
        category: 'Creations',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/callbot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/humanclone'),
        category: 'Creations',
        valueType: 'boolean',
        value: false,
        inSummary: false,
      },
      {
        name: t('Pricing/videosPerVideoBot'),
        category: 'Creations',
        valueType: 'string',
        value: '5',
      },
      {
        name: t('Pricing/maxsizepervideo'),
        category: 'Creations',
        valueType: 'string',
        value: '30MB',
      },
      {
        name: t('Pricing/key52'),
        category: 'Creations',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/scanLinks'),
        category: 'Creations',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/openai'),
        category: 'AI Models',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/anthropic'),
        category: 'AI Models',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/gemini'),
        category: 'AI Models',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/knowledge'),
        category: 'AI Models',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/sendvoice'),
        category: 'Voice Features',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/answervoice'),
        category: 'Voice Features',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/active'),
        category: 'Settings',
        valueType: 'string',
        value: '1',
      },
      {
        name: t('Pricing/domains'),
        category: 'Settings',
        valueType: 'string',
        value: '1',
      },
      {
        name: t('Pricing/hours'),
        category: 'Settings',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/agency'),
        category: 'Settings',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/manager'),
        category: 'Settings',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/support'),
        category: 'Settings',
        valueType: 'string',
        value: '72h',
      },
      {
        name: t('Pricing/name-avatar-icon'),
        category: 'Customization',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/colors'),
        category: 'Customization',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/badge'),
        category: 'Customization',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/sound'),
        category: 'Customization',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/videoicon'),
        category: 'Customization',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/shape'),
        category: 'Customization',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/poweredby'),
        category: 'Customization',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/sendmedia'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/leadform'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
        inSummary: true,
      },

      {
        name: t('Pricing/aiinscenario'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/sum'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/switch'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/voicemail'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/speech'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/automotions'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/advancefeatures'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/http'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/jscode'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/summarize'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/stats'),
        category: 'Analytics',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/history'),
        category: 'Analytics',
        valueType: 'boolean',
        value: false,
      },
    ],
    isFeatured: true,
  },
  {
    name: t('Pricing/key7'),
    code: {
      monthly: { USD: EPlanCodes.BASIC_MONTHLY, EUR: EPlanCodes.BASIC_MONTHLY_EU },
      annually: { USD: EPlanCodes.BASIC_ANNUAL, EUR: EPlanCodes.BASIC_ANNUAL_EU },
    },
    price: {
      monthly: 19,
      annually: 13,
    },
    actionBtnText: t('Pricing/key35'),
    features: [
      {
        name: t('Pricing/includpermonth'),
        category: 'Conversations per month',
        valueType: 'string',
        value: '500',
        inSummary: true,
      },
      {
        name: t('Pricing/whatsapp'),
        category: 'Conversations per month',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/telegram'),
        category: 'Conversations per month',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/key12'),
        category: 'Creations',
        valueType: 'string',
        value: t('Pricing/uptocustom', { count: 3 }),
      },
      {
        name: t('Pricing/textbot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/videobot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/quickbot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/docbot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
        inSummary: true,
      },
      {
        name: t('Pricing/sitebot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
        inSummary: true,
      },
      {
        name: t('Pricing/callbot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/humanclone'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/videosPerVideoBot'),
        category: 'Creations',
        valueType: 'string',
        value: t('Pricing/uptocustom', { count: 10 }),
      },
      {
        name: t('Pricing/maxsizepervideo'),
        category: 'Creations',
        valueType: 'string',
        value: '30MB',
      },
      {
        name: t('Pricing/key52'),
        category: 'Creations',
        valueType: 'string',
        value: t('Pricing/manual'),
      },
      {
        name: t('Pricing/scanLinks'),
        category: 'Creations',
        valueType: 'string',
        value: t('Pricing/uptocustom', { count: 20 }),
      },
      {
        name: t('Pricing/openai'),
        category: 'AI Models',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/anthropic'),
        category: 'AI Models',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/gemini'),
        category: 'AI Models',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/knowledge'),
        category: 'AI Models',
        valueType: 'string',
        value: t('Pricing/key33', { count: 4, size: 1 }),
      },
      {
        name: t('Pricing/sendvoice'),
        category: 'Voice Features',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/answervoice'),
        category: 'Voice Features',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/active'),
        category: 'Settings',
        valueType: 'string',
        value: t('Pricing/uptocustom', { count: 2 }),
      },
      {
        name: t('Pricing/domains'),
        category: 'Settings',
        valueType: 'string',
        value: t('Pricing/uptocustom', { count: 2 }),
      },
      {
        name: t('Pricing/hours'),
        category: 'Settings',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/sendmedia'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/leadform'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },

      {
        name: t('Pricing/aiinscenario'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/sum'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/switch'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/voicemail'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/speech'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/automotions'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/advancefeatures'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/http'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/jscode'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/summarize'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/agency'),
        category: 'Settings',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/manager'),
        category: 'Settings',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/support'),
        category: 'Settings',
        valueType: 'string',
        value: '48h',
      },
      {
        name: t('Pricing/name-avatar-icon'),
        category: 'Customization',
        valueType: 'boolean',
        value: true,
        inSummary: true,
      },
      {
        name: t('Pricing/colors'),
        category: 'Customization',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/badge'),
        category: 'Customization',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/sound'),
        category: 'Customization',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/videoicon'),
        category: 'Customization',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/shape'),
        category: 'Customization',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/poweredby'),
        category: 'Customization',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/stats'),
        category: 'Analytics',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/history'),
        category: 'Analytics',
        valueType: 'boolean',
        value: false,
      },
    ],
    isFeatured: true,
  },
  {
    name: t('Pricing/key8'),
    code: {
      monthly: {
        USD: EPlanCodes.ADVANCED_MONTHLY,
        EUR: EPlanCodes.ADVANCED_MONTHLY_EU,
      },
      annually: {
        USD: EPlanCodes.ADVANCED_ANNUAL,
        EUR: EPlanCodes.ADVANCED_ANNUAL_EU,
      },
    },
    price: {
      monthly: 39,
      annually: 26,
    },
    actionBtnText: t('Pricing/key35'),
    features: [
      {
        name: t('Pricing/includpermonth'),
        category: 'Conversations per month',
        valueType: 'string',
        value: '1500',
        inSummary: true,
      },
      {
        name: t('Pricing/whatsapp'),
        category: 'Conversations per month',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/telegram'),
        category: 'Conversations per month',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/key12'),
        category: 'Creations',
        valueType: 'string',
        value: t('Pricing/uptocustom', { count: 10 }),
      },
      {
        name: t('Pricing/textbot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/videobot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/quickbot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/docbot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/sitebot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/callbot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/humanclone'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/videosPerVideoBot'),
        category: 'Creations',
        valueType: 'string',
        value: t('Pricing/uptocustom', { count: 5 }),
      },
      {
        name: t('Pricing/key13'),
        category: 'Creations',
        valueType: 'string',
        value: t('Pricing/uptocustom', { count: 10 }),
      },
      {
        name: t('Pricing/maxsizepervideo'),
        category: 'Creations',
        valueType: 'string',
        value: '100MB',
      },
      {
        name: t('Pricing/key52'),
        category: 'Creations',
        valueType: 'string',
        value: t('Pricing/weekly'),
      },
      {
        name: t('Pricing/scanLinks'),
        category: 'Creations',
        valueType: 'string',
        value: t('Pricing/uptocustom', { count: 20 }),
      },
      {
        name: t('Pricing/openai'),
        category: 'AI Models',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/anthropic'),
        category: 'AI Models',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/gemini'),
        category: 'AI Models',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/knowledge'),
        category: 'AI Models',
        valueType: 'string',
        value: t('Pricing/key33', { count: 10, size: 10 }),
      },
      {
        name: t('Pricing/sendvoice'),
        category: 'Voice Features',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/answervoice'),
        category: 'Voice Features',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/active'),
        category: 'Settings',
        valueType: 'string',
        value: t('Pricing/uptocustom', { count: 5 }),
      },
      {
        name: t('Pricing/domains'),
        category: 'Settings',
        valueType: 'string',
        value: t('Pricing/uptocustom', { count: 10 }),
      },
      {
        name: t('Pricing/hours'),
        category: 'Settings',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/agency'),
        category: 'Settings',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/manager'),
        category: 'Settings',
        valueType: 'boolean',
        value: false,
      },
      {
        name: t('Pricing/support'),
        category: 'Settings',
        valueType: 'string',
        value: '48h',
      },
      {
        name: t('Pricing/sendmedia'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },

      {
        name: t('Pricing/leadform'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },

      {
        name: t('Pricing/aiinscenario'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/sum'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/switch'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/voicemail'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/speech'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/automotions'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/advancefeatures'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/http'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/jscode'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/summarize'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/name-avatar-icon'),
        category: 'Customization',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/colors'),
        category: 'Customization',
        valueType: 'boolean',
        value: true,
        inSummary: true,
      },
      {
        name: t('Pricing/badge'),
        category: 'Customization',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/sound'),
        category: 'Customization',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/videoicon'),
        category: 'Customization',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/shape'),
        category: 'Customization',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/poweredby'),
        category: 'Customization',
        valueType: 'boolean',
        value: true,
        inSummary: true,
      },

      {
        name: t('Pricing/stats'),
        category: 'Analytics',
        valueType: 'boolean',
        value: true,
        inSummary: true,
      },
      {
        name: t('Pricing/history'),
        category: 'Analytics',
        valueType: 'boolean',
        value: false,
      },
    ],
    isFeatured: true,
  },
  {
    name: t('Pricing/key9'),
    code: {
      monthly: {
        USD: EPlanCodes.ENTERPRISE_MONTHLY,
        EUR: EPlanCodes.ENTERPRISE_MONTHLY_EU,
      },
      annually: {
        USD: EPlanCodes.ENTERPRISE_ANNUAL,
        EUR: EPlanCodes.ENTERPRISE_ANNUAL_EU,
      },
    },
    price: {
      monthly: 370,
      annually: 299,
    },
    actionBtnText: t('Pricing/key35'),
    features: [
      {
        name: t('Pricing/includpermonth'),
        category: 'Conversations per month',
        valueType: 'string',
        value: t('Pricing/unlimitedwithapi'),
      },
      {
        name: t('Pricing/whatsapp'),
        category: 'Conversations per month',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/telegram'),
        category: 'Conversations per month',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/key12'),
        category: 'Creations',
        valueType: 'string',
        value: t('Pricing/unlimited'),
        inSummary: true,
      },
      {
        name: t('Pricing/textbot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/videobot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/quickbot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/docbot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/sitebot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/callbot'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/humanclone'),
        category: 'Creations',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/videosPerVideoBot'),
        category: 'Creations',
        valueType: 'string',
        value: t('Pricing/unlimited'),
      },
      {
        name: t('Pricing/maxsizepervideo'),
        category: 'Creations',
        valueType: 'string',
        value: '200MB',
      },
      {
        name: t('Pricing/key52'),
        category: 'Creations',
        valueType: 'string',
        value: t('Pricing/daily'),
      },
      {
        name: t('Pricing/scanLinks'),
        category: 'Creations',
        valueType: 'string',
        value: t('Pricing/uptocustom', { count: 50 }),
      },
      {
        name: t('Pricing/openai'),
        category: 'AI Models',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/anthropic'),
        category: 'AI Models',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/gemini'),
        category: 'AI Models',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/knowledge'),
        category: 'AI Models',
        valueType: 'string',
        value: t('Pricing/key33', { count: 18, size: 10 }),
      },
      {
        name: t('Pricing/sendvoice'),
        category: 'Voice Features',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/answervoice'),
        category: 'Voice Features',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/active'),
        category: 'Settings',
        valueType: 'string',
        value: t('Pricing/unlimited'),
        inSummary: true,
      },
      {
        name: t('Pricing/domains'),
        category: 'Settings',
        valueType: 'string',
        value: t('Pricing/unlimited'),
        inSummary: true,
      },
      {
        name: t('Pricing/hours'),
        category: 'Settings',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/sendmedia'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },

      {
        name: t('Pricing/leadform'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },

      {
        name: t('Pricing/aiinscenario'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/sum'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/switch'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/voicemail'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/speech'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/automotions'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/advancefeatures'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/http'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/jscode'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/summarize'),
        category: 'Automation Tools',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/name-avatar-icon'),
        category: 'Customization',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/colors'),
        category: 'Customization',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/badge'),
        category: 'Customization',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/sound'),
        category: 'Customization',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/videoicon'),
        category: 'Customization',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/shape'),
        category: 'Customization',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/poweredby'),
        category: 'Customization',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/agency'),
        category: 'Settings',
        valueType: 'boolean',
        value: true,
        inSummary: true,
      },
      {
        name: t('Pricing/manager'),
        category: 'Settings',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/support'),
        category: 'Settings',
        valueType: 'string',
        value: '12h',
      },
      {
        name: t('Pricing/stats'),
        category: 'Analytics',
        valueType: 'boolean',
        value: true,
      },
      {
        name: t('Pricing/history'),
        category: 'Analytics',
        valueType: 'boolean',
        value: true,
      },
    ],
    isFeatured: true,
  },
];

export const pricingCategories = (t: (key: string) => string) => [
  { label: t('Pricing/key1'), value: 'Conversations per month' },
  { label: t('Pricing/key2'), value: 'Creations' },
  { label: t('Pricing/key3'), value: 'AI Models' },
  { label: t('Pricing/automotiontools'), value: 'Automation Tools' },
  { label: t('Pricing/voice'), value: 'Voice Features' },
  { label: t('Pricing/key4'), value: 'Settings' },
  { label: t('Pricing/key5'), value: 'Customization' },
  { label: t('Pricing/analytics'), value: 'Analytics' },
  { label: t('Pricing/summary'), value: 'Summary' },
];
